import { CoinbaseIcon, MetaMaskIcon, SolanaIcon, TorusWalletIcon, WalletConnectCircleIcon, TorusWalletCircleIcon, CoinbaseCircleIcon } from "@novel/shared/icons";
import WalletConnectV2 from "@novel/shared/icons/WalletConnectV2.png";
import { IconWrapper } from "@novel/shared/components/PolarisIconWrapper";
import { ICryptoWallet } from "@novel/shared/interfaces/CryptoWallet";
import cx from "classnames";
import React from "react";
import Image from "next/legacy/image";
interface WalletIconProps {
  readonly className?: string;
  readonly gate?: boolean;
  readonly walletConnectionApp: ICryptoWallet["connectionApp"];
}
export function WalletIcon(props: WalletIconProps): JSX.Element {
  return <div className={cx("wallet-icon-wrapper", props.className)}>
            {(() => {
      switch (props.walletConnectionApp) {
        case "torus":
          {
            return <IconWrapper className="wallet-icon-container wallet-icon-torus" icon={props.gate ? TorusWalletCircleIcon : TorusWalletIcon} />;
          }
        case "wallet-connect-v2":
          {
            return <Image src={WalletConnectV2} height={48} width={48} alt="WalletConnectV2" />;
          }
        case "wallet-connect":
          {
            return <IconWrapper className="wallet-icon-container" icon={WalletConnectCircleIcon} />;
          }
        case "metamask":
          {
            return <IconWrapper className="wallet-icon-container" icon={MetaMaskIcon} />;
          }
        case "coinbase":
          {
            return <IconWrapper className="wallet-icon-container" icon={props.gate ? CoinbaseCircleIcon : CoinbaseIcon} />;
          }
        case "phantom":
          {
            return <IconWrapper className="wallet-icon-container" icon={SolanaIcon} />;
          }
      }
    })()}
        </div>;
}